/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Glyphicon} from "../../GlyphIcon";
import React from "react";

export const StreamBankRemoveItemButton = (props) => {
    const {
        show = true,
        onRemove = () => {},
    } = props;

    if (!show) { return null; }

    return (
        <div className="sb-mutable-list-remove-section">
            <a className="pndlm-remove-control" onClick={() => onRemove()}>
                <Glyphicon glyph="remove-sign"/>
            </a>
        </div>
    );
};
